import Box from '@mui/material/Box'
import Container, { ContainerProps } from '@mui/material/Container'

export type MainContainerProps = ContainerProps & {
  children: React.ReactNode,
  fullWidth?: boolean,
}

export default function MainContainer({ children, fullWidth, ...containerProps }: MainContainerProps) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        minHeight: 0,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Container
        sx={{
          padding: '24px',
          margin: 0,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
        {...(fullWidth && { maxWidth: false })}
        {...containerProps}
      >
        {children}
      </Container>
    </Box>
  )
}
